import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import Sidebar from './Sidebar';
import HomeScreen from '../Home/HomeScreen';
import LibraryScreen from '../Library/LibraryScreen';
import LeadsScreen from '../Leads/LeadsScreen';
import DealRoomScreen from '../DealRoom/DealRoomScreen';
import DemoHubScreen from '../DemoHub/DemoHubScreen';
import AnalyticsScreen from '../Analytics/AnalyticsScreen';
import TrackingScreen from '../Tracking/TrackingScreen';
import BuyerView from '../Client/BuyerView';
import TeamScreen from '../Team/TeamScreen';
import Toast from '../shared/Toast';
import type { Screen } from '../../types';

const SCREEN_MAP: Partial<Record<Screen, React.FC>> = {
  home:      HomeScreen,
  admin:     LibraryScreen,
  leads:     LeadsScreen,
  dealrooms: DealRoomScreen,
  demohub:   DemoHubScreen,
  analytics: AnalyticsScreen,
  tracking:  TrackingScreen,
  client:    BuyerView,
  team:      TeamScreen,
};

export default function AppShell() {
  const { screen } = useApp();
  const { isMobile, isTablet } = useBreakpoint();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const ScreenComponent = SCREEN_MAP[screen] || LibraryScreen;

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar
        forceCollapsed={isTablet}
        isMobile={isMobile}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        overflow: 'hidden', minWidth: 0, background: 'white',
      }}>
        {isMobile && (
          <div style={{
            height: '52px', flexShrink: 0,
            display: 'flex', alignItems: 'center',
            padding: '0 16px', gap: '12px',
            background: '#0D1825',
            borderBottom: '1px solid rgba(255,255,255,.07)',
          }}>
            <button
              type="button"
              title="Open navigation"
              onClick={() => setSidebarOpen(true)}
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.7)', cursor: 'pointer', fontSize: '22px', padding: '4px', lineHeight: 1, flexShrink: 0 }}
            >
              <i className="ti ti-menu-2" />
            </button>
            <div style={{ flex: 1, fontSize: '14px', fontWeight: '700', color: 'white', textAlign: 'center' }}>
              SalesBook
            </div>
            <div style={{ width: '30px' }} />
          </div>
        )}
        <ScreenComponent />
      </div>
      <Toast />
    </div>
  );
}
